import { apiUrl } from '@/api/client';

/**
 * URLs de `/widget/*` (p. ej. conversation-media firmado): en producción la PWA suele
 * estar en CloudFront y el API en otro host — usar VITE_API_ORIGIN cuando corresponda.
 */
export function resolveWidgetMediaUrl(pathOrUrl: string): string {
  if (!pathOrUrl) return '';
  if (pathOrUrl.startsWith('data:')) return pathOrUrl;

  if (pathOrUrl.startsWith('/widget') || pathOrUrl.startsWith('/api/')) {
    return apiUrl(pathOrUrl);
  }

  if (typeof window !== 'undefined') {
    if (pathOrUrl.startsWith('/widget')) {
      const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
      return `${window.location.origin}${path}`;
    }
    if (/^https?:\/\//i.test(pathOrUrl)) {
      try {
        const u = new URL(pathOrUrl);
        const loopback = u.hostname === 'localhost' || u.hostname === '127.0.0.1';
        if (loopback && u.pathname.startsWith('/widget')) {
          return `${window.location.origin}${u.pathname}${u.search}${u.hash}`;
        }
      } catch {
        /* ignore */
      }
      return pathOrUrl;
    }
  }

  if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) return pathOrUrl;
  if (import.meta.env.DEV && pathOrUrl.startsWith('/widget')) return pathOrUrl;
  return pathOrUrl;
}
